import { RDate } from "../../core";
import { DateRange } from "../../core/DateRange";
export class PreorderSettings {
    constructor(preorderSettings) {
        this.preorderSettings = preorderSettings;
    }
    get tag() {
        if (this.preorderSettings === null) {
            return "SameDay";
        }
        return this.preorderSettings.tag;
    }
    dateRange(now) {
        if (this.preorderSettings === null) {
            //TODO there shouldn't be null, we should use general setting from PR, and take into consideration flag "Zamawianie na przyszłość"
            return new DateRange(now, now.endOfDay());
        }
        else {
            switch (this.preorderSettings.tag) {
                case "SameDay":
                    return new DateRange(now, now.endOfDay());
                case "RelativeDate":
                    return new DateRange(now, now.add(this.preorderSettings.maxDays, "days").endOfDay());
                case "AbsoluteDate":
                    return new DateRange(RDate.fromString(this.preorderSettings.from, now.tz), RDate.fromString(this.preorderSettings.to, now.tz).endOfDay());
            }
        }
    }
}
